module Tapas.ViewModels {
    export class OrderDetailsViewModel extends Tapas.ViewModels.CartViewModel {
        public OrderDetailsOrderlineElements = ko.observable<HTMLElement>();

        constructor() {
            super();
        }
        public GetProductViemodelsFromDom(): Array<ProductViewModel> {
            //Get all the elements that the productviewmodel is bound to
            var $items = $(this.OrderDetailsOrderlineElements()).children();
            var result = [];
            $items.each((i, elm) => {
                var productViewModel: ProductViewModel = ko.dataFor(elm);
                result.push(productViewModel);
            });
            return result;
        }
        public AddAllToCart() {
            var all = this.GetProductViemodelsFromDom();
            if (all.length < 1) return;
            this.CartLoading(true);
            var addToCartArgs = new Array<Ftw.Dataservice.ICartAddArgs>();

            $.each(all, ((i, vm: ProductViewModel) => {
                var addToCartObj = <Ftw.Dataservice.ICartAddArgs>{
                    productId: vm.ProductId(),
                    quantity: vm.Quantity(),
                };
                addToCartArgs.push(addToCartObj);
            }));
            this.CartDataService.AddMultipleProducts(addToCartArgs).then((result) => {

            }).finally(() => {
                this.CartLoading(false);
            });
        } 

    }
}